import Client from "./client";

// The public support portal - none of these carry an access token, because
// nobody signing in is the point. `withCredentials` on the shared client (see
// client.js) is what carries the visitor cookie, which the API requires before
// it will accept anything written.

export const GetPublicSupportProject = (code) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/public/support/${code}`).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// Resolves {reference, ticket_url} - the link is returned as well as emailed,
// since the email may be slow, filtered, or impossible on an install with no
// mail configured.
// `client` is what the browser could say about itself (see lib/clientInfo.js) -
// the API sanitises it and appends it to the ticket body.
export const CreatePublicSupportTicket = ({code, subject, body, email, name, client}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/public/support/${code}`, {subject, body, email, name, client}).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

export const GetPublicSupportTicket = (token) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/public/support/ticket/${token}`).then((res) => {
            resolve(res.data.ticket);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

// The web reply form - the route that exists so a project can run support
// without receiving mail at all.
export const ReplyToPublicSupportTicket = ({token, body}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/public/support/ticket/${token}/reply`, {body}).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}
